import React from "react";
import { Link } from "react-router-dom";
import { Star, Hash, ScrollText, Home as HomeIcon, Flame, ArrowUpRight, HandHeart } from "lucide-react";

const CARDS = [
  {
    to: "/services/astrology", tag: "Jyotish Shastra", name: "Vedic Astrology",
    icon: Star, accent: "from-amber-500/20 to-yellow-600/10",
    blurb: "Read the eternal Vedic sky — Parashari, KP, birth chart, dashas & remedies.",
    bg: "bg-[#0A0C10]"
  },
  {
    to: "/services/numerology", tag: "अंक विद्या · Ank Vidya", name: "Numerology",
    icon: Hash, accent: "from-purple-500/10 to-pink-500/10",
    blurb: "Discover your birth number, life-path & name resonance. Calculate instantly.",
    bg: "bg-[#0A0C10]"
  },
  {
    to: "/services/tarot", tag: "Card Wisdom", name: "Tarot Reading",
    icon: ScrollText, accent: "from-violet-500/20 to-blue-500/10",
    blurb: "22 Major Arcana. Draw 1 or 3-card spread with intention.",
    bg: "bg-[#0A0C10]"
  },
  {
    to: "/services/vastu", tag: "Sacred Space", name: "Vastu Shastra",
    icon: HomeIcon, accent: "from-emerald-500/10 to-teal-500/10",
    blurb: "Eight directions. Five elements. Balance your home & office.",
    bg: "bg-[#0A0C10]"
  },
  {
    to: "/services/yantra-mantra-tantra", tag: "Ritual Technology", name: "Yantra · Mantra · Tantra",
    icon: Flame, accent: "from-orange-500/20 to-red-500/10",
    blurb: "Sacred geometry, sound vibration & tantric remedies for stubborn doshas.",
    bg: "bg-[#0A0C10]"
  },
  {
    to: "/astrologers", tag: "Live Consultation", name: "Pandit & Astrologer Booking",
    icon: HandHeart, accent: "from-rose-500/10 to-amber-500/10",
    blurb: "Talk 1-on-1. Chat, voice or video. Book pooja, yagya & tours.",
    bg: "bg-[#0A0C10]"
  },
];

export default function ServicesIndex() {
  return (
    <div className="max-w-7xl mx-auto px-6 py-16">
      <div className="mb-14 grid md:grid-cols-12 gap-6">
        <div className="md:col-span-8">
          <div className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-3">Our Services</div>
          <h1 className="font-serif text-4xl md:text-6xl tracking-tighter leading-tight">
            Every ritual, every remedy — <span className="italic gold-gradient">one sacred ceiling.</span>
          </h1>
        </div>
        <div className="md:col-span-4 md:pt-4">
          <p className="text-[#A0A4AB]">
            Six timeless Vedic sciences, distilled for the seeker of 2026. Explore each — each has its own soul.
          </p>
        </div>
      </div>

      <div className="grid md:grid-cols-6 gap-4">
        {CARDS.map((c, i) => {
          const Ic = c.icon;
          const wide = i === 0 || i === 4;
          return (
            <Link
              key={c.to}
              to={c.to}
              data-testid={`services-index-${i}`}
              className={`group relative rounded-2xl overflow-hidden border border-white/10 hover:border-[#D4AF37]/40 transition-all duration-300 hover:-translate-y-1 ${c.bg} ${wide ? "md:col-span-4" : "md:col-span-2"}`}
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${c.accent} opacity-60 group-hover:opacity-100 transition-opacity`} />
              <div className="relative p-8 min-h-[260px] flex flex-col justify-between">
                <div>
                  <Ic size={26} strokeWidth={1.3} className="text-[#D4AF37]"/>
                  <div className="text-[10px] uppercase tracking-[0.25em] text-[#D4AF37]/80 mt-6">{c.tag}</div>
                  <div className="font-serif text-2xl md:text-3xl mt-2">{c.name}</div>
                  <p className="text-sm text-[#A0A4AB] mt-3 leading-relaxed max-w-md">{c.blurb}</p>
                </div>
                <div className="flex items-center gap-2 text-[#D4AF37] text-sm mt-6 group-hover:gap-3 transition-all">
                  Explore <ArrowUpRight size={14}/>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
